import { Component, Input, OnInit, inject,Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Apiv1Service } from '../../../../services/apiv1.service';
import { finalize } from 'rxjs';
import { NgFor,NgIf } from '@angular/common';

@Component({
  selector: 'app-formadd',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './formadd.component.html',
  styleUrl: './formadd.component.scss',
})



export class FormaddComponent  implements OnInit {

constructor( private store: Apiv1Service) {}

@Output() submitted = new EventEmitter<void>();
@Input() config!: FormAddConfig;


  form!: FormGroup;

  private fb = inject(FormBuilder);

selectKeyMapping(key: string) : string {
  var k=key;
  var splitted = key.split('.');

  if (splitted.length > 1){
    k= splitted[0] + "Id";
  }
  console.log("FormaddComponent: selectKeyMapping: k: "+k);
  return k;
}


ngOnInit() {
    const group: any = {};

    // Create form controls dynamically



    this.config.fields.forEach(f => {
      group[this.selectKeyMapping(f.store_key)] = [''];
    });

    this.form = this.fb.group(group);
  }

loading = false;


  submit() {
    /*
    if (this.form.invalid) return;

    console.log("FormaddComponent: [this.form.value]: ["+JSON.stringify(this.form.value)+"]." );

    this.store.addForPath(this.config.postPath, this.form.value).subscribe(result => {
        console.log('Submitted:', result);
        this.submitted.emit();   // 🔥 notify parent
      });
*/
  if (this.form.invalid) return;

  this.loading = true;





  this.store.addForPath(this.config.postPath, this.form.value)
    .pipe(finalize(() => this.loading = false))   // <- always executed
    .subscribe({
      next: (result) => {
        console.log('Submitted:', result);
        this.ngOnInit();
        this.submitted.emit(); // notify parent

      },
      error: (err) => {
        console.error("Error submitting form:", err);
      }
    });
  }
}
export enum InputType {
  text     = "text",
  textarea = "textarea",
  select   = "select"
}
export interface FormAddField {
    label: string;
    placeholder?: string;
    hint?: string;
    store_key: string;
    type?:InputType;
    options?: Array<SelectOption>
  };
export interface FormAddConfig {
  title: string;
  buttonLabel: string;
  postPath: string;
  fields: Array<FormAddField>;
}

export interface SelectOption {
    value: number;
    label: string;
}